// 导入安装的axios
import axios from 'axios'

// 创建axios请求实例,并暴
const myaxios = axios.create({
    // baseURL: 'http://easygzh.natapp1.cc/houduan',
    // baseURL: 'http://127.0.0.1:8080',
    baseURL: 'http://nei.9jtx.cn',
    timeout: 500000,
    headers: { 'X-Custom-Header': 'foobar' }
});

//暴露接口
export default myaxios;
